import { SNoop } from '@obvious.tech/util/validation/schemas'
import { defineEntity } from '../../defineEntity'
import { IConnector } from '@obvious.tech/constellation'

export const Connector = defineEntity('Connector', {
  endpoint: 'connectors/api/Connector',
  schema: SNoop<IConnector>(),
})
